// This file was automatically generated from ptdata.model.denialMedOrder.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.model.denialMedOrder');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.denialMedOrder.signature = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8SignoffText">', (opt_data.signUserBehalfName) ? 'Signed off for ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.signUserName)) : soy.$$escapeHtml(opt_data.signUserName)) + ' by ' + soy.$$escapeHtml(opt_data.signUserBehalfName) + ' on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : '') : 'Signed off by ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.signUserName)) : soy.$$escapeHtml(opt_data.signUserName)) + ' on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : ''), (opt_data.supervisingPhysicianName) ? ' - Supervisor: ' + soy.$$escapeHtml(opt_data.supervisingPhysicianName) : '', '</p>');
  if (!opt_sb) return output.toString();
};
